import { render, staticRenderFns } from "./chooseMedicine.vue?vue&type=template&id=a3515a76&"
import script from "./chooseMedicine.vue?vue&type=script&lang=js&"
export * from "./chooseMedicine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports